export default __webpack_public_path__ + "static/media/level 2.9ec43f27.svg";